import { topicItems } from '@/mocks/home';

const colorMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-700',
  primary: 'bg-primary-100 text-primary-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">话题热榜</h2>
        <p className="section-subtitle">读者最关注的漫画话题与热门讨论，看看大家都在聊什么</p>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-colors hover:opacity-80 ${colorMap[item.color]}`}
            >
              <span className="whitespace-nowrap">{item.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}